import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { CompleteTranslationFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-translation-fragments.generated';
import { gql } from '@apollo/client';
import { PriceEditDisplayInfoDetailFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-price-edit-display-info-fragments.generated';
import { PricingInvoiceHistoryFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/blocs/documents/pricing-invoice-history-fragment.generated';
import { PricingWeeklyPurchaseQuantityFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/blocs/documents/pricing-weekly-purchase-quantity-fragment.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const CustomerDetailHeaderFieldsFragmentDoc = gql`
  fragment CustomerDetailHeaderFields on CustomerDetailHeader {
    line_items_total
    margin_percentage
    order_count
    price_floor_enabled
    price_floor_mode
    restaurant {
      name
      uuid
    }
    restaurant_account_id
    restaurant_id
  }
`;
export const CustomerDetailRowFieldsFragmentDoc = gql`
  fragment CustomerDetailRowFields on CustomerDetailRow {
    supplier_id
    cost_in_micros_delta
    current_cost_in_micros
    current_margin_percentage
    current_price_in_micros
    gross_margin_delta_in_micros
    gross_profit_per_unit_in_micros
    invoice_history {
      ...PricingInvoiceHistoryFields
    }
    last_cost_in_micros
    last_margin_percentage
    last_price_in_micros
    line_items_total
    previous_margin_percentage
    price_edit_display_info {
      ...PriceEditDisplayInfoDetailFields
    }
    price_in_micros_delta
    restaurant_id
    variant_pack {
      external_item_id
      item {
        display_name
        uuid
      }
      pack {
        unit
        uuid
      }
      uuid
    }
    variant_pack_id
    weekly_purchase_quantities {
      ...PricingWeeklyPurchaseQuantityFields
    }
  }
  ${PricingInvoiceHistoryFieldsFragmentDoc}
  ${PriceEditDisplayInfoDetailFieldsFragmentDoc}
  ${PricingWeeklyPurchaseQuantityFieldsFragmentDoc}
`;
export const PricingCustomerDetailDataDocument = gql`
  query PricingCustomerDetailData($restaurantUUID: uuid!, $supplierUUID: uuid) {
    getCustomerDetailData(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      header {
        ...CustomerDetailHeaderFields
      }
      price_edit_display_headers {
        category
        is_confidential
        key
        translation {
          ...CompleteTranslationFields
        }
      }
      rows {
        ...CustomerDetailRowFields
      }
    }
  }
  ${CustomerDetailHeaderFieldsFragmentDoc}
  ${CompleteTranslationFieldsFragmentDoc}
  ${CustomerDetailRowFieldsFragmentDoc}
`;
export function usePricingCustomerDetailDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >(PricingCustomerDetailDataDocument, options);
}
export function usePricingCustomerDetailDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >(PricingCustomerDetailDataDocument, options);
}
export type PricingCustomerDetailDataQueryHookResult = ReturnType<
  typeof usePricingCustomerDetailDataQuery
>;
export type PricingCustomerDetailDataLazyQueryHookResult = ReturnType<
  typeof usePricingCustomerDetailDataLazyQuery
>;
export type PricingCustomerDetailDataQueryResult = Apollo.QueryResult<
  Types.PricingCustomerDetailDataQuery,
  Types.PricingCustomerDetailDataQueryVariables
>;

/**
 * Wrapped version of useGeneratedPricingCustomerDetailDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPricingCustomerDetailDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >(PricingCustomerDetailDataDocument, options);
}

/**
 * Wrapped version of useGeneratedPricingCustomerDetailDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPricingCustomerDetailDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PricingCustomerDetailDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PricingCustomerDetailDataQuery,
    Types.PricingCustomerDetailDataQueryVariables
  >(PricingCustomerDetailDataDocument, lazyOptions);
}
